<template>
  <Modal title="Title" v-model="showFormModal" class-name="card-modal" :width="450">
    <div slot="header">
      <h4>{{title}}</h4>
    </div>
    <Form ref="SurveyProcessed" :model="survey" :label-width="100">
      <Row class="widget-container">
        <i-col :xs="24" :sm="24" :md="24" :lg="24">
          <FormItem label="Survey Name" align="left">
            <Select v-model="selectedSurvey" transfer clearable>
              <Option v-for="item in items" :value="item.formId" :key="item.formId">
                {{item.formName}}
              </Option>
            </Select>
          </FormItem>
        </i-col>
      </Row>
    </Form>
    <div slot="footer">
      <Button size="large" @click="handleReset;showFormModal=false" style="margin-left: 8px">Cancel</Button>
      <Button size="large" class="submit" type="success" @click="goToSurveyProcessed">Continue</Button>
    </div>
  </Modal>
</template>
<script>
  import Router from '../../router';
  import {bus} from '../../main'

  export default {
    data() {
      return {
        init: null,
        index: 0,
        action: 'add',
        title: 'ADD FORM',
        showFormModal: false,
        survey: {
          answers: [{
            answerValue: null,
            dataType: null,
            others: null,
            questionId: null,
          }],
          questions: [{
            allowOther: false,
            choices: [],
            formId: null,
            optional: null,
            order: null,
            questionId: null,
            title: null,
            type: null,
            visible: true,
          }],
          createdBy: null,
          createdDate: null,
          deleted: false,
          deletionDate: null,
          deviceType: null,
          formId: null,
          formName: null,
          leadId: null,
        },
        items: [],
        selectedSurvey: ''
      }
    },
    methods: {
      openSurveys() {
        this.handleReset();
        this.showFormModal = true;
        this.title = 'Choose Survey';
        this.action = 'view';
      },
      setTitleValue(list, index) {
        if (list) {
          this.items = [];
          list.map(a => {
            this.items.push(a);
          });
        }
      },
      handleReset() {
        let self = this;
        self.selectedSurvey = '';
        Object.keys(this.survey).forEach(function (key) {
          self.survey[key] = null;
        });
      },
      goToSurveyProcessed() {
        Router.push({name: 'QuestionnaireProcessed'});
        let survey = this.items.filter(a => a.formId === this.selectedSurvey)[0];
        setTimeout(() => {
          bus.$emit('LoadSurveys', survey);
        }, 300);
      }
    }
  }
</script>
<style scoped>
  .ivu-input, .ivu-btn {
    border: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/c_LeadsProcessed/_surveyProcessed.vue